import { useState, useEffect } from 'react';
import { getThoughtsByIntention } from '../services/thoughtService';

/**
 * Fetch the thoughts for an `?intention=X` view.
 *
 * The home page only loads draft thoughts, so intention-tagged (triaged)
 * thoughts are no longer in the global array. This hook queries them directly
 * when an intention filter is active, and returns an empty list otherwise.
 *
 * @param {string|null} intention - the active intention filter, or null/empty
 * @returns {{ intentionThoughts: Array, loading: boolean }}
 */
const useIntentionThoughts = (intention) => {
  const [intentionThoughts, setIntentionThoughts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!intention) {
      setIntentionThoughts([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    getThoughtsByIntention(intention)
      .then((rows) => {
        if (cancelled) return;
        setIntentionThoughts(rows);
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setIntentionThoughts([]);
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [intention]);

  return { intentionThoughts, loading };
};

export default useIntentionThoughts;
